<template>
  <Spacer />
  <section class="section">
    <div id="book-a-demo">
      <!-- <h1>Contact Us</h1> -->
      <div class="hero">
        <div class="content">
          <h1>Kubma</h1>
        </div>
        <div class="right_side">
          <div class="right_side_content" v-if="false">
            <div class="contact">
              <div class="form">
                <h4>Contact us</h4>
                <div class="custom-form">
                  <div id="message"></div>
                  <form id="contact-form" @submit.prevent="handler">
                    <div class="row form_info">
                      <div class="col-xs-12">
                        <div class="form-group position-relative">
                          <i class="mdi mdi-account ml-3 icons"></i>
                          <div class="input_wrapper">
                            <input
                              id="name"
                              ref="nameInput"
                              v-model="name"
                              required
                              name="name"
                              type="text"
                              class="form-control pl-5"
                              @focus="isNameToggle = true"
                              @blur="
                                () =>
                                  name
                                    ? (isNameToggle = true)
                                    : (isNameToggle = false)
                              "
                            />
                            <span
                              class="placeholder-addon"
                              :class="{ disable: isNameToggle }"
                              @click="handleSpan('name')"
                              >Name <b> * </b></span
                            >
                          </div>
                        </div>
                      </div>
                      <!--end col-->
                      <div class="col-xs-12">
                        <div class="form-group position-relative">
                          <i class="mdi mdi-email ml-3 icons"></i>
                          <div class="input_wrapper">
                            <input
                              id="email"
                              ref="emailInput"
                              v-model="email"
                              required
                              name="email"
                              type="email"
                              class="form-control pl-5"
                              @focus="isEmailToggle = true"
                              @blur="
                                () =>
                                  email
                                    ? (isEmailToggle = true)
                                    : (isEmailToggle = false)
                              "
                            />
                            <span
                              class="placeholder-addon"
                              :class="{ disable: isEmailToggle }"
                              @click="handleSpan('email')"
                              >Email ID <b> * </b></span
                            >
                          </div>
                        </div>
                      </div>
                      <div class="col-xs-12">
                        <div class="form-group position-relative">
                          <i class="mdi mdi-phone ml-3 icons"></i>
                          <div class="input_wrapper">
                            <div class="country_code">
                              <b>+</b>
                              <input
                                v-model="countryCode"
                                type="text"
                                maxlength="3"
                                minlength="0"
                                typeof="number"
                              />
                            </div>
                            <input
                              id="mobile"
                              ref="mobileInput"
                              v-model="mobile"
                              name="mobile"
                              type="text"
                              pattern="[0-9].{4,}"
                              minlength="5"
                              maxlength="10"
                              class="form-control pl-5"
                              @focus="isMobileToggle = true"
                              @blur="
                                () =>
                                  mobile
                                    ? (isMobileToggle = true)
                                    : (isMobileToggle = false)
                              "
                            />
                            <span
                              class="placeholder-addon last"
                              style="left: 24%"
                              :class="{ disable: isMobileToggle }"
                              @click="handleSpan('mobile')"
                              >Mobile No.
                            </span>
                          </div>
                        </div>
                      </div>
                      <!--end col-->
                    </div>
                    <!--end row-->
                    <div class="row button_container">
                      <button
                        id="submit"
                        type="submit"
                        name="send"
                        class="submitBnt btn btn-primary btn-block"
                        :disabled="submit"
                      >
                        <img
                          :src="`${baseUrl}/static/icons/long-tail-arrow.svg`"
                          alt=""
                        />
                      </button>
                      <!-- .msg-sent hide after success -->
                      <div v-show="flash" id="simple-msg" class="p-2">
                        {{ msg }}
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div class="links_container" v-if="false">
              <ul class="links" @click="handleHashLink">
                <NuxtLink to="/about">About Us</NuxtLink>
                <NuxtLink to="/privacy-policy">Privacy Policy</NuxtLink>
                <NuxtLink to="/credits">Credits</NuxtLink>
                <NuxtLink to="/terms">Terms of Use</NuxtLink>
                <a
                  target="_blank"
                  href="https://www.linkedin.com/company/travvir/"
                  >LinkedIn</a
                >
                <a target="_blank" href="https://x.com/Travvir_AI">X.com</a>
              </ul>
            </div>
          </div>
        </div>
        <!--end col-->
      </div>
      <div class="icons-wrapper" v-if="false">
        <a
          href="https://play.google.com/store/apps/details?id=com.travvir.studio"
          target="_blank"
          rel="noopener noreferrer"
          ><NuxtImg
            :src="`${baseUrl}/static/images/PlayStore.png`"
            alt="Playtore"
            loading="lazy"
            :placeholder="`${baseUrl}/property-preview-images-web/default.svg`"
        /></a>
        <a
          href="https://apps.apple.com/in/app/travvir-360-views-from-phone/id6443536819"
          target="_blank"
          rel="noopener noreferrer"
          ><NuxtImg
            :src="`${baseUrl}/static/images/AppStore.png`"
            alt="AppStore"
            loading="lazy"
            :placeholder="`${baseUrl}/property-preview-images-web/default.svg`"
        /></a>
      </div>
      <div class="rights">
        <h3>© {{ new Date().getFullYear() }} Kubma</h3>
        <h2>All rights are reserved.</h2>
      </div>
    </div>
  </section>
</template>

<script setup>
import axios from "axios";

// Reactive data
const config = useRuntimeConfig();
const baseUrl = config.public.NUXT_CDN_URL;
const name = ref(null);
const email = ref(null);
const mobile = ref(null);
const countryCode = ref(91);
const submit = ref(false);
const flash = ref(false);
const isNameToggle = ref(false);
const isEmailToggle = ref(false);
const isMobileToggle = ref(false);
const msg = ref(null);
const nameInput = ref(null);
const emailInput = ref(null);
const mobileInput = ref(null);

// Methods
const handler = async () => {
  try {
    const form = document.querySelector("form");
    const mobileRegix = /^\+(?:[0-9] ?){6,14}[0-9]$/;
    let mobilenumber = `+${countryCode.value}${mobile.value}`;

    //empty check
    if (!(name.value && email.value)) return;
    if (mobile.value) {
      if (!mobileRegix.test(mobilenumber)) {
        isMobileToggle.value = true;
        notify("mobile");
        msg.value = "Please Enter Valid Mobile No.";
        return;
      }
    }
    //queue check
    if (submit.value) return;
    const url = config.public.NIXT_API_URL + "/contact";
    submit.value = true;
    const res = await axios.post(url, {
      name: name.value,
      email: email.value,
      mobile: mobilenumber,
    });
    if (res.status == 200) {
      form.reset();
      isNameToggle.value = isEmailToggle.value = isMobileToggle.value = false;
      name.value = email.value = mobile.value = null;
      submit.value = false;
      msg.value = " We will contact you shortly.";
      notify("success");
    }
  } catch (error) {
    msg.value = error.response.data.error.email;
    submit.value = false;
    notify("error");
  }
};

const notify = (info) => {
  if (info == "mobile") {
    flash.value = true;
    setTimeout(() => {
      flash.value = false;
    }, 3000);
  } else {
    flash.value = true;
    setTimeout(() => {
      flash.value = false;
    }, 3000);
  }
};

const handleSpan = (event) => {
  if (event == "name") {
    nameInput.value.focus();
    isNameToggle.value = true;
  } else if (event == "email") {
    emailInput.value.focus();
    isEmailToggle.value = true;
  } else if (event == "mobile") {
    mobileInput.value.focus();
    isMobileToggle.value = true;
  }
  return;
};

const handleHashLink = () => {
  window.scrollTo(0, 0);
};
</script>

<style lang="scss" scoped>
.icons-wrapper {
  gap: 1rem;
  z-index: 100;
  display: flex;
  position: relative;
  width: fit-content;
  margin-top: -6rem;
  padding: 0rem 4rem;
  a {
    width: 10vw;
  }
  @include respond-below(md) {
    margin-top: 0rem;
    margin: auto;
    padding: 0rem 2rem;
    justify-content: space-between;
    @include mq(landscape-1) {
      justify-content: start;
    }
    a {
      width: calc(50% - 1rem);
      &:last-child {
        margin-right: 1rem;
      }
      @include mq(landscape-1) {
        width: 14vw;
      }
      img {
        width: 100%;
        max-width: 100%;
        height: auto;
      }
    }
  }
}
.right_side {
  width: calc(100% - 55%);
  display: block;
  @include respond-below(md) {
    width: 100%;
  }
  &_content {
    padding-bottom: 3rem;
    display: flex;
    justify-content: end;
    @include respond-below(md) {
      padding-bottom: 1rem;
      display: block;
      .contact {
        justify-content: center;
      }
    }
    @include mq(landscape-1) {
      gap: 0rem;
    }
  }
}
h1 {
  font-size: 3.6rem;
  color: #fff;
  line-height: 1.206em;
  margin-bottom: 4rem;
  font-weight: 700;
  letter-spacing: -0.02rem;
  text-align: center;
  @include respond-below(sm) {
    font-size: 1.9rem;
    margin-bottom: 2rem;
  }
}
section.section {
  font-family: $theme-font;
  display: flex;
  flex-direction: column;
  .rights {
    margin: 1.5rem 0rem;
    display: flex;
    justify-content: end;
    padding-right: 2rem;
    @include respond-below(sm) {
      padding: 0rem 2rem;
      flex-direction: column;
      // @include mq(landscape-1) {
      //   flex-direction: row;
      //   font-size: $text-xs;
      //   margin-top: 0rem;
      //   justify-content: end;
      // }
    }
    h3 {
      font-size: 0.875rem;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.9);
      text-decoration: unset;
      // margin-right: 2rem;
      @include respond-below(sm) {
        font-size: 1rem;
        text-align: start;
        line-height: 1.25rem;
        padding: 0.2rem 0rem;
        padding-top: 0rem;
      }
    }
    h2 {
      font-size: 0.875rem;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.9);
      text-decoration: unset;
      // margin-right: 2rem;
      @include respond-below(sm) {
        // margin-top: 2rem;
        font-size: 1.125rem;
        text-align: start;
        line-height: 1.25rem;
        padding: 0.2rem 0rem;
        padding-top: 0rem;
      }
    }
  }
  @include respond-below(sm) {
    margin-top: 0rem;
    padding: 2rem 0rem;
  }
}
.rounded {
  padding: 2rem;
  @include respond-below(sm) {
    margin-top: 2rem;
  }
}
.text-danger {
  color: tomato;
}
.form-group {
  font-size: 0.875rem;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.9);
  text-decoration: unset;
  // margin-right: 2rem;
  padding: 0.25rem 0.5rem;
  color: rgba(255, 255, 255, 1);
  display: flex;
  flex-direction: column;
  margin-top: 0.1rem;
  width: 100%;
  label {
    font-size: 0.875rem;
    color: #fff;
  }
  .input_wrapper {
    display: flex;
    align-items: center;
    gap: 0.2rem;
    position: relative;
    .country_code {
      border-radius: 5px;
      background: inherit;
      border: 1px solid rgba(255, 255, 255, 0.5);
      display: flex;
      align-items: center;
      padding: 0rem 0rem 0rem 0.4rem;
      input {
        border: none;
        outline: none;
        padding: 0.8rem 0.4rem 0.8rem 0rem;
        width: 2rem;
      }
      b {
        padding: 0rem 0.2rem 0rem 0.1rem;
        color: inherit;
      }
    }
    input {
      // font-size: 1rem;
      font-size: 0.875rem;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.9);
      text-decoration: unset;
      // margin-right: 2rem;
      padding: 0.25rem 0.5rem;
      color: inherit;
      background-color: black;
      width: 100%;
      outline: none;
      border: 1px solid rgba(255, 255, 255, 0.5);
      padding: 0.8rem 0.4rem;
      border-radius: 5px;
      &::placeholder {
        opacity: 0.6;
        font-size: 1rem;
      }
    }
  }
}

.button_container {
  margin-top: 1rem;
  margin-left: 0.5rem;
  padding: 0rem;
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: flex-end;
  align-items: flex-end;
  @include respond-below(sm) {
    display: flex;
    margin-left: 1.2rem;
    justify-content: flex-end;
    padding-right: 1rem;
    align-items: center;
  }
}
button {
  border: none;
  cursor: pointer;
  // border: 1px solid white;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  background: #000;
  border-radius: 10px;
  color: white;
  padding: 0.4rem;
  margin-top: 0.5rem;
}
#simple-msg {
  color: #fff;
  font-size: 0.875rem;
  display: flex;
  justify-content: center;
  margin-top: 0.6rem;
}
h4 {
  font-size: 1.875rem;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.9);
  text-decoration: unset;
  margin-bottom: 0.7rem;
}
.hero {
  position: relative;
  z-index: 100;
  padding: 0rem 4rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 1rem;
  @include respond-below(sm) {
    flex-direction: row;
    align-items: end;
    padding: 0rem 2rem;
    gap: 0rem;
  }
  .content {
    width: 55%;
    height: 18.75rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 3rem;
    gap: 0rem;
    @include respond-below(md) {
      display: none;
      gap: 1rem;
    }
    // @include mq(landscape-1) {
    //   display: none;
    //   gap: 1rem;
    // }
    h1 {
      font-style: normal;
      font-weight: 600;
      font-size: 12vw;
      line-height: 110%;
      color: #ffffff;
      @include respond-below(sm) {
        margin-bottom: 0rem;
        font-size: 10vw;
      }
    }
  }
  .links_container {
    @extend %v-center;
    justify-content: flex-end;
    height: calc(2rem * 7.4);
    margin-top: 1.2rem;
    @include respond-below(md) {
      height: 100%;
      margin-top: 4rem;
      width: 18.75rem;
      margin-inline: auto;
      gap: 1rem;
      justify-content: center;
      &::before {
        content: "Kubma";
        line-height: 1;
        color: #fff;
        line-height: 1.206em;
        font-size: 2.5rem;
        font-weight: 500;
        text-align: center;
      }
    }
    ul {
      color: white;
      white-space: nowrap;
      overflow: hidden;
      flex-wrap: nowrap;
      gap: 0rem;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      list-style: none;
      font-style: normal;
      font-weight: 600;
      margin-left: 4rem;
      font-size: 1.31rem;
      // line-height: 51px;
      color: #ffffff;
      @include respond-below(lg) {
        margin-left: 1rem;
      }
      @include respond-below(md) {
        border-left: 1px solid #eee;
        margin-left: 0rem;
        width: 12.25rem;
        padding-left: 1.5rem;
        font-size: 1rem;
        line-height: 1.2;
        gap: 0.5rem;
        justify-content: space-around;
      }
      @include mq(landscape-1) {
        border-left: 1px solid #eee;
        margin-left: 0rem;
        // width: 12.25rem;
        padding-left: 0.7rem;
        font-size: 0.9rem;
        line-height: 0.9;
        gap: 0rem;
        justify-content: space-around;
      }
      li,
      a {
        font-size: 0.875rem;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.9);
        text-decoration: unset;
        padding: 0.25rem 0.5rem;
        line-height: 2.2rem;
        cursor: pointer;
        text-decoration: none;
        @include respond-below(md) {
          font-size: 1rem;
          line-height: unset;
        }
      }
    }
  }
}
.responsive {
  display: flex;
  gap: 1rem;
  align-items: center;
  flex-direction: column;
  @include respond-below(sm) {
    width: 95vw;
    flex-direction: column;
  }
}
.contact {
  display: flex;
  align-items: center;
  justify-content: start;
  // padding-left: ;
  gap: 3rem;
  @include respond-below(sm) {
    gap: 1rem;
  }
  .form {
    height: 18.75rem;
    width: 17.5rem;
    @include respond-below(md) {
      width: 18.75rem;
    }
    @include mq(landscape-1) {
      width: 90%;
    }
  }
}

footer {
  display: flex;
  flex-flow: column wrap;
  height: 100%;
  color: white;
  margin-left: 2rem;
  font-size: 1rem;
  /* background-color: white; */
  @include respond-below(sm) {
    margin-left: unset;
    padding: 0;
    font-size: 0.875rem;
    margin-top: 2rem;
  }

  .company_name {
    p {
      /* font-weight: 700; */
      font-size: 1.4em;
      margin-block: 1.5em;
    }
  }

  .links {
    list-style: none;
    display: flex;
    flex-flow: column wrap;

    li,
    a {
      cursor: pointer;
      all: unset;
      width: max-content;
      font-size: 0.875rem;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.9);
      text-decoration: unset;
      // margin-right: 2rem;
      padding: 0.25rem 0.5rem;
      &:hover {
        text-decoration: underline;
        cursor: pointer;
      }

      /* flex-basis: 50%; */
      &:not(:first-child) {
        margin-top: 1rem;
      }
    }
  }
}
span {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 3%;
  font-size: 0.875rem;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.9);
  text-decoration: unset;
  // margin-right: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  // cursor: pointer;
  @include mq(landscape-1) {
    &.placeholder-addon {
      &.last {
        left: 30% !important;
      }
    }
  }
}
.disable {
  transition: all 0.2s ease;
  opacity: 0;
}
.form_info {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
</style>
